import { render } from "./ModifierComponent.vue?vue&type=template&id=1aaa920f&scoped=true"
import script from "./ModifierComponent.vue?vue&type=script&lang=js"
export * from "./ModifierComponent.vue?vue&type=script&lang=js"

import "./ModifierComponent.vue?vue&type=style&index=0&id=1aaa920f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaa920f"]])

export default __exports__